import { BrowserRouter, Route, Routes } from "react-router-dom";
// import HomePageOne from "./pages/HomePageOne";
// import HomePageTwo from "./pages/HomePageTwo";
// import HomePageThree from "./pages/HomePageThree";
// import HomePageFour from "./pages/HomePageFour";
// import HomePageFive from "./pages/HomePageFive";
// import HomePageSix from "./pages/HomePageSix";
// import HomePageSeven from "./pages/templates/HomePageSeven";
// import EmailPage from "./pages/templates/EmailPage";
// import AddUserPage from "./pages/templates/AddUserPage";
// import AlertPage from "./pages/templates/AlertPage";
// import AssignRolePage from "./pages/templates/AssignRolePage";
// import AvatarPage from "./pages/templates/AvatarPage";
// import BadgesPage from "./pages/templates/BadgesPage";
// import ButtonPage from "./pages/templates/ButtonPage";
// import CalendarMainPage from "./pages/templates/CalendarMainPage";
// import CardPage from "./pages/templates/CardPage";
// import CarouselPage from "./pages/templates/CarouselPage";
// import ChatEmptyPage from "./pages/templates/ChatEmptyPage";
// import ChatMessagePage from "./pages/templates/ChatMessagePage";
// import ChatProfilePage from "./pages/templates/ChatProfilePage";
// import CodeGeneratorNewPage from "./pages/templates/CodeGeneratorNewPage";
// import CodeGeneratorPage from "./pages/templates/CodeGeneratorPage";
// import ColorsPage from "./pages/templates/ColorsPage";
// import ColumnChartPage from "./pages/templates/ColumnChartPage";
// import CompanyPage from "./pages/templates/CompanyPage";
// import CurrenciesPage from "./pages/templates/CurrenciesPage";
// import DropdownPage from "./pages/templates/DropdownPage";
import ErrorPage from "./pages/templates/ErrorPage";
// import FaqPage from "./pages/templates/FaqPage";
// import ForgotPasswordPage from "./pages/templates/ForgotPasswordPage";
// import FormLayoutPage from "./pages/templates/FormLayoutPage";
// import FormValidationPage from "./pages/templates/FormValidationPage";
// import FormPage from "./pages/templates/FormPage";
// import GalleryPage from "./pages/templates/GalleryPage";
// import ImageGeneratorPage from "./pages/templates/ImageGeneratorPage";
// import ImageUploadPage from "./pages/templates/ImageUploadPage";
// import InvoiceAddPage from "./pages/templates/InvoiceAddPage";
// import InvoiceEditPage from "./pages/templates/InvoiceEditPage";
// import InvoiceListPage from "./pages/templates/InvoiceListPage";
// import InvoicePreviewPage from "./pages/templates/InvoicePreviewPage";
// import KanbanPage from "./pages/templates/KanbanPage";
// import LanguagePage from "./pages/templates/LanguagePage";
// import LineChartPage from "./pages/templates/LineChartPage";
// import ListPage from "./pages/templates/ListPage";
// import MarketplaceDetailsPage from "./pages/templates/MarketplaceDetailsPage";
// import MarketplacePage from "./pages/templates/MarketplacePage";
// import NotificationAlertPage from "./pages/templates/NotificationAlertPage";
// import NotificationPage from "./pages/templates/NotificationPage";
// import PaginationPage from "./pages/templates/PaginationPage";
// import PaymentGatewayPage from "./pages/templates/PaymentGatewayPage";
// import PieChartPage from "./pages/templates/PieChartPage";
// import PortfolioPage from "./pages/templates/PortfolioPage";
// import PricingPage from "./pages/templates/PricingPage";
// import ProgressPage from "./pages/templates/ProgressPage";
// import RadioPage from "./pages/templates/RadioPage";
// import RoleAccessPage from "./pages/templates/RoleAccessPage";
// import SignInPage from "./pages/templates/SignInPage";
// import SignUpPage from "./pages/templates/SignUpPage";
// import StarRatingPage from "./pages/templates/StarRatingPage";
// import StarredPage from "./pages/templates/StarredPage";
// import SwitchPage from "./pages/templates/SwitchPage";
// import TableBasicPage from "./pages/templates/TableBasicPage";
// import TableDataPage from "./pages/templates/TableDataPage";
// import TabsPage from "./pages/templates/TabsPage";
// import TagsPage from "./pages/templates/TagsPage";
// import TermsConditionPage from "./pages/templates/TermsConditionPage";
// import TextGeneratorPage from "./pages/templates/TextGeneratorPage";
// import ThemePage from "./pages/templates/ThemePage";
// import TooltipPage from "./pages/templates/TooltipPage";
// import TypographyPage from "./pages/templates/TypographyPage";
// import UsersGridPage from "./pages/templates/UsersGridPage";
// import UsersListPage from "./pages/templates/UsersListPage";
// import ViewDetailsPage from "./pages/templates/ViewDetailsPage";
// import VideoGeneratorPage from "./pages/templates/VideoGeneratorPage";
// import VideosPage from "./pages/templates/VideosPage";
import ViewProfilePage from "./pages/templates/ViewProfilePage";
// import VoiceGeneratorPage from "./pages/templates/VoiceGeneratorPage";
// import WalletPage from "./pages/templates/WalletPage";
// import WidgetsPage from "./pages/templates/WidgetsPage";
// import WizardPage from "./pages/templates/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
// import TextGeneratorNewPage from "./pages/templates/TextGeneratorNewPage";
// import HomePageEight from "./pages/HomePageEight";
// import HomePageNine from "./pages/HomePageNine";
// import HomePageTen from "./pages/HomePageTen";
// import HomePageEleven from "./pages/HomePageEleven";
// import GalleryGridPage from "./pages/templates/GalleryGridPage";
// import GalleryMasonryPage from "./pages/templates/GalleryMasonryPage";
// import GalleryHoverPage from "./pages/templates/GalleryHoverPage";
// import BlogPage from "./pages/templates/BlogPage";
// import BlogDetailsPage from "./pages/templates//BlogDetailsPage";
// import AddBlogPage from "./pages/templates//AddBlogPage";
// import TestimonialsPage from "./pages/templates//TestimonialsPage";
// import ComingSoonPage from "./pages/templates//ComingSoonPage";
import AccessDeniedPage from "./pages/templates//AccessDeniedPage";
// import MaintenancePage from "./pages/templates//MaintenancePage";
// import BlankPagePage from "./pages/templates//BlankPagePage";
import ReleasePage from "./pages/Release/ReleasePage";
import LoginPage from "./pages/LoginPage/LoginPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
// import PrivateRoute from "./masterLayout/PrivateLayout";
import Catalogue from "./pages/Catalogue/Catalogue";
import MasterLayout from "./masterLayout/MasterLayout";
import MusicLabel from "./pages/MusicLabel/MusicLabel";
import Reporting from "./pages/Reporting/Reporting";
import Dashboard from "./pages/Dashboard/Dashboard";
// import OtpPage from "./components/OtpPage";
import ChangePassword from "./components/ChangePassword";
import { ProfileProvider } from "./context/ProfileContext";
import { AuthProvider } from "./context/AuthContext";
import RoleBasedRoute from "./masterLayout/RoleBaseRoute";
import AdminList from "./pages/Admin/AdminList";
import ReleaseApproval from "./pages/ReleaseApproval/ReleaseApproval";
import Users from "./pages/Users/Users";
import Payment from "./pages/Payment/Payment";
import Channel from "./pages/Channel/Channel";
import UploadFiles from "./pages/UploadFiles/UploadFiles";
import Bank from "./pages/Bank/Bank";
import UploadBa from "./pages/UploadBA/UploadBA";
import ListAllSongs from "./pages/Song/ListAllSongs";
// looker
import UploadReport from "./pages/Looker/UploadReport";
import ListReport from "./pages/Looker/ListReport";
import OverviewReport from "./pages/Looker/OverviewReport";



const allRoles = ["RL2411111120977", "RL2411062373407","RL2411065833191" ,"RL2505041947488"]


function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <AuthProvider>
        <ProfileProvider>
          <Routes>
            {/* <Route exact path='/' element={<HomePageOne />} /> */}
            {/* <Route exact path='/otp' element={<OtpPage />} /> */}
            <Route exact path='*' element={<ErrorPage />} />
            <Route exact path='/' element={
              <RoleBasedRoute allowedRoles={allRoles}>
                <MasterLayout>
                <Dashboard />
                </MasterLayout>
              </RoleBasedRoute>
              } />
            <Route exact path='/dashboard' element={
              <RoleBasedRoute allowedRoles={allRoles}>
                <MasterLayout>
                <Dashboard />
                </MasterLayout>
              </RoleBasedRoute>
              } />
            <Route exact path='/login' element={<LoginPage />} />
            <Route exact path='/register' element={<RegisterPage />} />
            {/* <Route path='*' element={<Navigate to='/login' replace />} /> */}
            <Route exact path='/release' element={
              // <PrivateRoute>
                <RoleBasedRoute allowedRoles={["RL2411111120977","RL2505041947488"]}>
                  <ReleasePage />
                </RoleBasedRoute>
              // </PrivateRoute>
              } />
              <Route exact path='/catalogue' element={
                <RoleBasedRoute allowedRoles={["RL2411111120977","RL2505041947488"]}>
                  <MasterLayout>
                    <Catalogue />
                  </MasterLayout>
                </RoleBasedRoute>
              } />
               <Route exact path='/user' element={
                <RoleBasedRoute allowedRoles={["RL2411111120977"]}>
                  <MasterLayout>
                    <Users/>
                  </MasterLayout>
                </RoleBasedRoute>
              } />
              <Route exact path ='/reporting' element={
                <RoleBasedRoute allowedRoles={["RL2411111120977","RL2505041947488"]}>
                  <MasterLayout>
                    <Reporting/>
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/list-admin" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407"]}>
                  <MasterLayout>
                    <AdminList/>
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path='/musiclabel' element={
                <RoleBasedRoute allowedRoles={["RL2411065833191","RL2411062373407"]}>
                  <MasterLayout>
                    <MusicLabel />
                  </MasterLayout>
                </RoleBasedRoute>
              } />
              <Route exact path="/release-approval" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407"]}>
                  <MasterLayout>
                    <ReleaseApproval />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/payment" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407","RL2411111120977"]}>
                  <MasterLayout>
                    <Payment />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/bank" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407","RL2411111120977"]}>
                  <MasterLayout>
                    <Bank />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/channel" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407"]}>
                  <MasterLayout>
                    <Channel />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/upload-files" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407" ]}>
                  <MasterLayout>
                    <UploadFiles />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/upload-ba" element={
                <RoleBasedRoute allowedRoles={["RL2411065833191", "RL2411062373407", "RL2411111120977" ]}>
                  <MasterLayout>
                   <UploadBa/>
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/list-all-songs" element={
                <RoleBasedRoute allowedRoles={allRoles}>
                  <MasterLayout>
                    <ListAllSongs />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/change-password" element={
                <RoleBasedRoute allowedRoles={allRoles}>
                  <MasterLayout>
                    <ChangePassword />
                  </MasterLayout>
                </RoleBasedRoute>
                } />
                <Route exact path='/view-profile' element={
                  <RoleBasedRoute allowedRoles={['RL2411111120977',"RL2411062373407",'RL2411065833191']}>
                    <MasterLayout>
                      <ViewProfilePage />
                    </MasterLayout>
                  </RoleBasedRoute>
                  } />
                  <Route exact path="/access-denied" element={
                    <AccessDeniedPage />
                  }/>

              {/* Looker Report */}
              <Route exact path="/looker-upload-report" element={
                <RoleBasedRoute allowedRoles={['RL2411062373407', 'RL2411065833191']}>
                  <MasterLayout>
                    <UploadReport />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/looker-report" element={
                <RoleBasedRoute allowedRoles={allRoles}>
                  <MasterLayout>
                    <ListReport />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
              <Route exact path="/looker-overview" element={
                <RoleBasedRoute allowedRoles={allRoles}>
                  <MasterLayout>
                    <OverviewReport />
                  </MasterLayout>
                </RoleBasedRoute>
              }/>
            {/* <Route exact path='/index-1' element={<HomePageOne />} />
            <Route exact path='/index-2' element={<HomePageTwo />} />
            <Route exact path='/index-3' element={<HomePageThree />} />
            <Route exact path='/index-4' element={<HomePageFour />} />
            <Route exact path='/index-5' element={<HomePageFive />} />
            <Route exact path='/index-6' element={<HomePageSix />} />
            <Route exact path='/index-7' element={<HomePageSeven />} />
            <Route exact path='/index-8' element={<HomePageEight />} />
            <Route exact path='/index-9' element={<HomePageNine />} />
            <Route exact path='/index-10' element={<HomePageTen />} />
            <Route exact path='/index-11' element={<HomePageEleven />} /> */}

            {/* SL */}
            {/* <Route exact path='/add-user' element={<AddUserPage />} />
            <Route exact path='/alert' element={<AlertPage />} />
            <Route exact path='/assign-role' element={<AssignRolePage />} />
            <Route exact path='/avatar' element={<AvatarPage />} />
            <Route exact path='/badges' element={<BadgesPage />} />
            <Route exact path='/button' element={<ButtonPage />} />
            <Route exact path='/calendar-main' element={<CalendarMainPage />} />
            <Route exact path='/calendar' element={<CalendarMainPage />} />
            <Route exact path='/card' element={<CardPage />} />
            <Route exact path='/carousel' element={<CarouselPage />} />
            <Route exact path='/chat-empty' element={<ChatEmptyPage />} />
            <Route exact path='/chat-message' element={<ChatMessagePage />} />
            <Route exact path='/chat-profile' element={<ChatProfilePage />} />
            <Route exact path='/code-generator' element={<CodeGeneratorPage />} />
            <Route
              exact
              path='/code-generator-new'
              element={<CodeGeneratorNewPage />}
            /> */}
            {/* <Route exact path='/colors' element={<ColorsPage />} />
            <Route exact path='/column-chart' element={<ColumnChartPage />} />
            <Route exact path='/company' element={<CompanyPage />} />
            <Route exact path='/currencies' element={<CurrenciesPage />} />
            <Route exact path='/dropdown' element={<DropdownPage />} />
            <Route exact path='/email' element={<EmailPage />} />
            <Route exact path='/faq' element={<FaqPage />} />
            <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
            <Route exact path='/form-layout' element={<FormLayoutPage />} />
            <Route exact path='/form-validation' element={<FormValidationPage />} />
            <Route exact path='/form' element={<FormPage />} />

            <Route exact path='/gallery' element={<GalleryPage />} />
            <Route exact path='/gallery-grid' element={<GalleryGridPage />} />
            <Route exact path='/gallery-masonry' element={<GalleryMasonryPage />} />
            <Route exact path='/gallery-hover' element={<GalleryHoverPage />} />

            <Route exact path='/blog' element={<BlogPage />} />
            <Route exact path='/blog-details' element={<BlogDetailsPage />} />
            <Route exact path='/add-blog' element={<AddBlogPage />} />

            <Route exact path='/testimonials' element={<TestimonialsPage />} />
            <Route exact path='/coming-soon' element={<ComingSoonPage />} />
            <Route exact path='/maintenance' element={<MaintenancePage />} />
            <Route exact path='/blank-page' element={<BlankPagePage />} />

            <Route exact path='/image-generator' element={<ImageGeneratorPage />} />
            <Route exact path='/image-upload' element={<ImageUploadPage />} />
            <Route exact path='/invoice-add' element={<InvoiceAddPage />} />
            <Route exact path='/invoice-edit' element={<InvoiceEditPage />} />
            <Route exact path='/invoice-list' element={<InvoiceListPage />} />
            <Route exact path='/invoice-preview' element={<InvoicePreviewPage />} />
            <Route exact path='/kanban' element={<KanbanPage />} />
            <Route exact path='/language' element={<LanguagePage />} />
            <Route exact path='/line-chart' element={<LineChartPage />} />
            <Route exact path='/list' element={<ListPage />} />
            <Route
              exact
              path='/marketplace-details'
              element={<MarketplaceDetailsPage />}
            />
            <Route exact path='/marketplace' element={<MarketplacePage />} />
            <Route
              exact
              path='/notification-alert'
              element={<NotificationAlertPage />}
            />
            <Route exact path='/notification' element={<NotificationPage />} />
            <Route exact path='/pagination' element={<PaginationPage />} />
            <Route exact path='/payment-gateway' element={<PaymentGatewayPage />} />
            <Route exact path='/pie-chart' element={<PieChartPage />} />
            <Route exact path='/portfolio' element={<PortfolioPage />} />
            <Route exact path='/pricing' element={<PricingPage />} />
            <Route exact path='/progress' element={<ProgressPage />} />
            <Route exact path='/radio' element={<RadioPage />} />
            <Route exact path='/role-access' element={<RoleAccessPage />} />
            <Route exact path='/sign-in' element={<SignInPage />} />
            <Route exact path='/sign-up' element={<SignUpPage />} />
            <Route exact path='/star-rating' element={<StarRatingPage />} />
            <Route exact path='/starred' element={<StarredPage />} />
            <Route exact path='/switch' element={<SwitchPage />} />
            <Route exact path='/table-basic' element={<TableBasicPage />} />
            <Route exact path='/table-data' element={<TableDataPage />} />
            <Route exact path='/tabs' element={<TabsPage />} />
            <Route exact path='/tags' element={<TagsPage />} />
            <Route exact path='/terms-condition' element={<TermsConditionPage />} />
            <Route
              exact
              path='/text-generator-new'
              element={<TextGeneratorNewPage />}
            />
            <Route exact path='/text-generator' element={<TextGeneratorPage />} />
            <Route exact path='/theme' element={<ThemePage />} />
            <Route exact path='/tooltip' element={<TooltipPage />} />
            <Route exact path='/typography' element={<TypographyPage />} />
            <Route exact path='/users-grid' element={<UsersGridPage />} />
            <Route exact path='/users-list' element={<UsersListPage />} />
            <Route exact path='/view-details' element={<ViewDetailsPage />} />
            <Route exact path='/video-generator' element={<VideoGeneratorPage />} />
            <Route exact path='/videos' element={<VideosPage />} />
            
            <Route exact path='/voice-generator' element={<VoiceGeneratorPage />} />
            <Route exact path='/wallet' element={<WalletPage />} />
            <Route exact path='/widgets' element={<WidgetsPage />} />
            <Route exact path='/wizard' element={<WizardPage />} /> */}

            
          </Routes>
        </ProfileProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
